// extracted by mini-css-extract-plugin
module.exports = {"layout":"aed17b9412--layout--F9R4x","phone":"aed17b9412--phone--Wdrud","tablet":"aed17b9412--tablet--zilHY","desktop":"aed17b9412--desktop--GVjO5"};